module.exports = __webpack_public_path__ + "static/media/beam_ballance.f9161b01.svg";